import React, { useEffect, useState, Fragment } from 'react';
import { motion } from 'framer-motion';
const revealVariants = {
  hidden: {
    opacity: 0,
    y: 40
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.75,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};
const revealLeftVariants = {
  hidden: {
    opacity: 0,
    x: -40
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.75,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};
const revealRightVariants = {
  hidden: {
    opacity: 0,
    x: 40
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.75,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};
export function Home() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };
  return <main className="min-h-screen bg-[#060606] text-[#F6F2E9] selection:bg-[#C9A84C]/30 selection:text-[#E8C96A]" data-id="element-414">
      {/* NAV */}
      <nav className={`fixed top-0 left-0 right-0 z-50 flex justify-between items-center transition-all duration-500 ${isScrolled ? 'bg-[#060606]/95 py-4 px-6 md:px-16 backdrop-blur-md border-b border-[#F6F2E9]/10' : 'bg-transparent py-7 px-6 md:px-16'}`} data-id="element-415">
        <div className="font-serif text-[17px] tracking-[0.45em] text-[#C9A84C] uppercase font-normal" data-id="element-416">
          Élite Identity
        </div>
        <div className="hidden md:flex gap-9 items-center" data-id="element-417">
          <a href="#evento" className="text-[11px] tracking-[0.15em] uppercase text-[#F6F2E9]/60 hover:text-[#C9A84C] transition-colors" data-id="element-418">
            Evento
          </a>
          <a href="#quien" className="text-[11px] tracking-[0.15em] uppercase text-[#F6F2E9]/60 hover:text-[#C9A84C] transition-colors" data-id="element-419">
            El Método
          </a>
          <a href="#planes" className="text-[11px] tracking-[0.15em] uppercase text-[#F6F2E9]/60 hover:text-[#C9A84C] transition-colors" data-id="element-420">
            Planes
          </a>
          <a href="#daniel" className="text-[11px] tracking-[0.15em] uppercase text-[#F6F2E9]/60 hover:text-[#C9A84C] transition-colors" data-id="element-421">
            Daniel S.
          </a>
        </div>
        <a href="#planes" className="text-[10px] tracking-[0.2em] uppercase text-[#C9A84C] border border-[#C9A84C]/40 py-3 px-7 hover:bg-[#C9A84C] hover:text-[#060606] transition-all" data-id="element-422">
          Quiero entrar
        </a>
      </nav>
      {/* HERO */}
      <section className="h-screen flex flex-col justify-center items-center text-center relative overflow-hidden" data-id="element-423">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_100%_70%_at_50%_-10%,rgba(201,168,76,0.09)_0%,transparent_60%),radial-gradient(ellipse_60%_40%_at_90%_100%,rgba(201,168,76,0.05)_0%,transparent_50%)]" data-id="element-424" />

        <div className="absolute w-[600px] h-[600px] rounded-full blur-[80px] bg-[radial-gradient(circle,rgba(201,168,76,0.07),transparent_70%)] -top-[20%] -left-[10%] animate-[orbFloat_25s_linear_infinite]" data-id="element-425" />
        <div className="absolute w-[400px] h-[400px] rounded-full blur-[80px] bg-[radial-gradient(circle,rgba(201,168,76,0.05),transparent_70%)] -bottom-[10%] -right-[5%] animate-[orbFloat_18s_linear_infinite_-9s]" data-id="element-426" />

        <div className="absolute inset-0 hero-grid" data-id="element-427" />

        <div className="relative z-10 flex flex-col items-center px-4" data-id="element-428">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.15
        }} className="inline-flex items-center gap-3 border border-[#C9A84C]/25 py-2 px-5 mb-12" data-id="element-429">
            <div className="w-1.5 h-1.5 bg-[#C9A84C] rounded-full animate-[blink_2s_infinite]" data-id="element-430" />
            <span className="text-[10px] tracking-[0.35em] uppercase text-[#F6F2E9]/60" data-id="element-431">
              Mentoría Privada · Daniel S. · 2026
            </span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.9,
          delay: 0.35
        }} className="font-serif text-[clamp(80px,14vw,180px)] font-light leading-[0.85] tracking-[-0.02em] mb-2" data-id="element-432">
            ÉLITE<em className="italic text-[#C9A84C] block" data-id="element-433">IDENTITY</em>
          </motion.h1>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.55
        }} className="w-px h-16 bg-gradient-to-b from-[#C9A84C] to-transparent my-8" data-id="element-434" />

          <motion.p initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.7
        }} className="text-[clamp(15px,1.8vw,18px)] leading-[1.85] text-[#F6F2E9]/60 max-w-[500px] mb-14" data-id="element-435">
            Construye quien eres. Monetiza lo que sabes.
            <br data-id="element-436" />
            Expande tu vida — sin límite de lugar ni de ingreso.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.85
        }} className="flex gap-4 justify-center flex-wrap" data-id="element-437">
            <a href="#" className="btn-g" data-id="element-438">
              <span data-id="element-439">Ver los planes</span>
            </a>
            <a href="#quien" className="btn-o" data-id="element-440">
              Descubrir más
            </a>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 1.2
      }} className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2" data-id="element-441">
          <p className="text-[9px] tracking-[0.5em] text-[#C9A84C] uppercase" data-id="element-442">
            Desplazar
          </p>
          <div className="w-px h-[60px] bg-[#F6F2E9]/10 relative overflow-hidden" data-id="element-443">
            <div className="absolute top-[-100%] left-0 w-full h-full bg-[#C9A84C] animate-[scrollTrack_2s_ease-in-out_infinite]" data-id="element-444" />
          </div>
        </motion.div>
      </section>
      {/* STATS BAR */}
      <div className="bg-[#0C0C0C] border-y border-[#F6F2E9]/10 overflow-hidden" data-id="element-445">
        <div className="flex animate-[marquee_20s_linear_infinite] hover:[animation-play-state:paused]" data-id="element-446">
          {[1, 2].map(group => <Fragment key={group} data-id="element-447">
              <div className="flex items-center gap-5 py-5 px-14 whitespace-nowrap shrink-0" data-id="element-448">
                <span className="font-serif text-[28px] text-[#C9A84C]" data-id="element-449">3</span>
                <span className="text-[11px] tracking-[0.15em] uppercase text-[#F6F2E9]/60" data-id="element-450">
                  Niveles de mentoría
                </span>
              </div>
              <div className="w-1 h-1 bg-[#C9A84C]/30 rounded-full shrink-0 my-auto" data-id="element-451" />

              <div className="flex items-center gap-5 py-5 px-14 whitespace-nowrap shrink-0" data-id="element-452">
                <span className="font-serif text-[28px] text-[#C9A84C]" data-id="element-453">
                  SER
                </span>
                <span className="text-[11px] tracking-[0.15em] uppercase text-[#F6F2E9]/60" data-id="element-454">
                  El primer paso
                </span>
              </div>
              <div className="w-1 h-1 bg-[#C9A84C]/30 rounded-full shrink-0 my-auto" data-id="element-455" />

              <div className="flex items-center gap-5 py-5 px-14 whitespace-nowrap shrink-0" data-id="element-456">
                <span className="font-serif text-[28px] text-[#C9A84C]" data-id="element-457">
                  HACER
                </span>
                <span className="text-[11px] tracking-[0.15em] uppercase text-[#F6F2E9]/60" data-id="element-458">
                  La estrategia correcta
                </span>
              </div>
              <div className="w-1 h-1 bg-[#C9A84C]/30 rounded-full shrink-0 my-auto" data-id="element-459" />

              <div className="flex items-center gap-5 py-5 px-14 whitespace-nowrap shrink-0" data-id="element-460">
                <span className="font-serif text-[28px] text-[#C9A84C]" data-id="element-461">
                  TENER
                </span>
                <span className="text-[11px] tracking-[0.15em] uppercase text-[#F6F2E9]/60" data-id="element-462">
                  Resultados inevitables
                </span>
              </div>
              <div className="w-1 h-1 bg-[#C9A84C]/30 rounded-full shrink-0 my-auto" data-id="element-463" />

              <div className="flex items-center gap-5 py-5 px-14 whitespace-nowrap shrink-0" data-id="element-464">
                <span className="font-serif text-[28px] text-[#C9A84C]" data-id="element-465">
                  $97
                </span>
                <span className="text-[11px] tracking-[0.15em] uppercase text-[#F6F2E9]/60" data-id="element-466">
                  Para empezar
                </span>
              </div>
              <div className="w-1 h-1 bg-[#C9A84C]/30 rounded-full shrink-0 my-auto" data-id="element-467" />

              <div className="flex items-center gap-5 py-5 px-14 whitespace-nowrap shrink-0" data-id="element-468">
                <span className="font-serif text-[28px] text-[#C9A84C]" data-id="element-469">
                  IA
                </span>
                <span className="text-[11px] tracking-[0.15em] uppercase text-[#F6F2E9]/60" data-id="element-470">
                  Herramienta central
                </span>
              </div>
              <div className="w-1 h-1 bg-[#C9A84C]/30 rounded-full shrink-0 my-auto" data-id="element-471" />

              <div className="flex items-center gap-5 py-5 px-14 whitespace-nowrap shrink-0" data-id="element-472">
                <span className="font-serif text-[28px] text-[#C9A84C]" data-id="element-473">
                  100%
                </span>
                <span className="text-[11px] tracking-[0.15em] uppercase text-[#F6F2E9]/60" data-id="element-474">
                  Orientado a resultados
                </span>
              </div>
              <div className="w-1 h-1 bg-[#C9A84C]/30 rounded-full shrink-0 my-auto" data-id="element-475" />
            </Fragment>)}
        </div>
      </div>
      {/* EVENTO ESPECIAL */}
      <section id="evento" className="relative overflow-hidden bg-[#060606]" data-id="element-476">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_90%_70%_at_50%_0%,rgba(201,168,76,0.11)_0%,transparent_55%),radial-gradient(ellipse_40%_40%_at_10%_80%,rgba(201,168,76,0.06)_0%,transparent_50%),radial-gradient(ellipse_30%_30%_at_90%_70%,rgba(201,168,76,0.05)_0%,transparent_50%)]" data-id="element-477" />
        <div className="absolute inset-0 bg-[linear-gradient(rgba(201,168,76,0.025)_1px,transparent_1px),linear-gradient(90deg,rgba(201,168,76,0.025)_1px,transparent_1px)] bg-[length:60px_60px]" data-id="element-478" />

        {/* Decorative border + corners (desktop only) */}
        <div className="absolute inset-8 border border-[#C9A84C]/20 pointer-events-none hidden md:block" data-id="element-479" />
        <div className="absolute top-8 left-8 w-6 h-6 border-t-2 border-l-2 border-[#C9A84C] hidden md:block" data-id="element-480" />
        <div className="absolute top-8 right-8 w-6 h-6 border-t-2 border-r-2 border-[#C9A84C] hidden md:block" data-id="element-481" />
        <div className="absolute bottom-8 left-8 w-6 h-6 border-b-2 border-l-2 border-[#C9A84C] hidden md:block" data-id="element-482" />
        <div className="absolute bottom-8 right-8 w-6 h-6 border-b-2 border-r-2 border-[#C9A84C] hidden md:block" data-id="element-483" />

        <div className="relative z-10 max-w-[1000px] mx-auto py-24 md:py-28 px-6 md:px-20 text-center" data-id="element-484">
          <motion.div variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
          once: true
        }} data-id="element-485">
            <div className="inline-flex items-center gap-2.5 border border-[#C9A84C]/35 py-2 px-5 mb-9 bg-[#C9A84C]/5" data-id="element-486">
              <div className="w-[7px] h-[7px] bg-[#E05454] rounded-full animate-[livePulse_1.4s_ease-in-out_infinite]" data-id="element-487" />
              <span className="text-[10px] tracking-[0.45em] uppercase text-[#C9A84C]" data-id="element-488">
                Evento en vivo · Zoom
              </span>
            </div>
          </motion.div>

          <motion.p variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-[10px] tracking-[0.55em] uppercase text-[#C9A84C] mb-5" data-id="element-489">
            Evento Especial · Daniel S.
          </motion.p>

          <motion.h2 variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="font-serif text-[clamp(42px,7vw,88px)] font-light leading-[0.9] tracking-[-0.02em] mb-3" data-id="element-490">
            DESPIERTA
            <br data-id="element-491" />
            EL PODER DE
            <br data-id="element-492" />
            <em className="italic text-[#C9A84C]" data-id="element-493">CREAR</em>
          </motion.h2>

          <motion.p variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="font-serif text-[clamp(18px,2.5vw,26px)] italic text-[#F6F2E9]/60 mb-12 leading-[1.4]" data-id="element-494">
            Una experiencia de transformación en vivo.
            <br data-id="element-495" />
            Una sesión. Un antes y un después.
          </motion.p>

          {/* Meta info */}
          <motion.div variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="inline-flex flex-col md:flex-row border border-[#C9A84C]/20 mb-16" data-id="element-496">
            <div className="py-3.5 px-8 flex flex-col gap-1 border-b md:border-b-0 md:border-r border-[#C9A84C]/20" data-id="element-497">
              <span className="text-[9px] tracking-[0.45em] uppercase text-[#C9A84C]/50" data-id="element-498">
                Formato
              </span>
              <span className="font-serif text-[18px] text-[#F6F2E9]" data-id="element-499">
                Zoom en vivo
              </span>
            </div>
            <div className="py-3.5 px-8 flex flex-col gap-1 border-b md:border-b-0 md:border-r border-[#C9A84C]/20" data-id="element-500">
              <span className="text-[9px] tracking-[0.45em] uppercase text-[#C9A84C]/50" data-id="element-501">
                Duración
              </span>
              <span className="font-serif text-[18px] text-[#F6F2E9]" data-id="element-502">
                90 minutos
              </span>
            </div>
            <div className="py-3.5 px-8 flex flex-col gap-1 border-b md:border-b-0 md:border-r border-[#C9A84C]/20" data-id="element-503">
              <span className="text-[9px] tracking-[0.45em] uppercase text-[#C9A84C]/50" data-id="element-504">
                Cupos
              </span>
              <span className="font-serif text-[18px] text-[#F6F2E9]" data-id="element-505">
                Limitados
              </span>
            </div>
            <div className="py-3.5 px-8 flex flex-col gap-1" data-id="element-506">
              <span className="text-[9px] tracking-[0.45em] uppercase text-[#C9A84C]/50" data-id="element-507">
                Inversión
              </span>
              <span className="font-serif text-[18px] text-[#F6F2E9]" data-id="element-508">
                Gratuito
              </span>
            </div>
          </motion.div>

          {/* 3 Puntos */}
          <motion.div variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="grid md:grid-cols-3 gap-1 mb-16 text-left" data-id="element-509">
            <div className="bg-[#C9A84C]/5 border border-[#C9A84C]/15 p-9 relative overflow-hidden group transition-all duration-500 hover:bg-[#C9A84C]/10 hover:border-[#C9A84C]/25" data-id="element-510">
              <div className="absolute top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-[#C9A84C] to-transparent origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500" data-id="element-511" />
              <div className="font-serif text-[56px] font-light text-[#C9A84C]/15 leading-none mb-4 italic" data-id="element-512">
                01
              </div>
              <h3 className="font-serif text-[22px] text-[#C9A84C] mb-2.5 font-normal" data-id="element-513">
                Activa tu identidad creadora
              </h3>
              <p className="text-[13.5px] leading-[1.8] text-[#F6F2E9]/60 mb-4" data-id="element-514">
                Descubrirás exactamente quién necesitas ser para que lo que
                quieres construir — marca, negocio, vida — empiece a
                manifestarse. No es teoría. Es un proceso guiado en vivo que
                rompe los patrones que te han tenido estancado.
              </p>
              <span className="inline-block text-[11px] tracking-[0.15em] text-[#C9A84C] py-1.5 px-3.5 border border-[#C9A84C]/25 bg-[#C9A84C]/5" data-id="element-515">
                → Saldrás sabiendo quién eres y qué crear
              </span>
            </div>
            <div className="bg-[#C9A84C]/5 border border-[#C9A84C]/15 p-9 relative overflow-hidden group transition-all duration-500 hover:bg-[#C9A84C]/10 hover:border-[#C9A84C]/25" data-id="element-516">
              <div className="absolute top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-[#C9A84C] to-transparent origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500" data-id="element-517" />
              <div className="font-serif text-[56px] font-light text-[#C9A84C]/15 leading-none mb-4 italic" data-id="element-518">
                02
              </div>
              <h3 className="font-serif text-[22px] text-[#C9A84C] mb-2.5 font-normal" data-id="element-519">
                Construye tu idea de negocio en 60 minutos
              </h3>
              <p className="text-[13.5px] leading-[1.8] text-[#F6F2E9]/60 mb-4" data-id="element-520">
                Con un ejercicio práctico guiado por Daniel, definirás tu
                proyecto digital, tu propuesta de valor y tu primer paso de
                monetización — usando IA como acelerador. Saldrás con algo
                concreto, no con más ideas sueltas.
              </p>
              <span className="inline-block text-[11px] tracking-[0.15em] text-[#C9A84C] py-1.5 px-3.5 border border-[#C9A84C]/25 bg-[#C9A84C]/5" data-id="element-521">
                → Saldrás con una idea clara lista para ejecutar
              </span>
            </div>
            <div className="bg-[#C9A84C]/5 border border-[#C9A84C]/15 p-9 relative overflow-hidden group transition-all duration-500 hover:bg-[#C9A84C]/10 hover:border-[#C9A84C]/25" data-id="element-522">
              <div className="absolute top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-[#C9A84C] to-transparent origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500" data-id="element-523" />
              <div className="font-serif text-[56px] font-light text-[#C9A84C]/15 leading-none mb-4 italic" data-id="element-524">
                03
              </div>
              <h3 className="font-serif text-[22px] text-[#C9A84C] mb-2.5 font-normal" data-id="element-525">
                Reprograma tu mente para el siguiente nivel
              </h3>
              <p className="text-[13.5px] leading-[1.8] text-[#F6F2E9]/60 mb-4" data-id="element-526">
                Una sesión de reprogramación mental en tiempo real:
                identificarás el bloqueo principal que te ha impedido crecer, y
                lo reemplazarás con una creencia nueva que soporte la versión de
                ti que quieres construir. El cambio ocurre aquí.
              </p>
              <span className="inline-block text-[11px] tracking-[0.15em] text-[#C9A84C] py-1.5 px-3.5 border border-[#C9A84C]/25 bg-[#C9A84C]/5" data-id="element-527">
                → Saldrás con una mentalidad diferente, garantizado
              </span>
            </div>
          </motion.div>

          {/* CTA buttons */}
          <motion.div variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="flex gap-3.5 justify-center flex-wrap" data-id="element-528">
            <a href="#" className="bg-[#C9A84C] text-[#060606] py-[18px] px-[52px] text-[12px] tracking-[0.22em] uppercase font-sans font-medium transition-all duration-300 inline-flex items-center gap-3 relative overflow-hidden group" data-id="element-529">
              <svg className="relative z-10" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-530">
                <rect x="3" y="4" width="18" height="18" rx="2" data-id="element-531" />
                <line x1="16" y1="2" x2="16" y2="6" data-id="element-532" />
                <line x1="8" y1="2" x2="8" y2="6" data-id="element-533" />
                <line x1="3" y1="10" x2="21" y2="10" data-id="element-534" />
              </svg>
              <span className="relative z-10" data-id="element-535">Agendar mi lugar ahora</span>
              <div className="absolute inset-0 bg-[#E8C96A] -translate-x-full group-hover:translate-x-0 transition-transform duration-300" data-id="element-536" />
            </a>
            <a href="#" className="bg-transparent text-[#F6F2E9]/60 py-[18px] px-10 text-[11px] tracking-[0.2em] uppercase border border-[#F6F2E9]/15 font-sans font-light transition-all duration-300 hover:border-[#F6F2E9]/35 hover:text-[#F6F2E9]" data-id="element-537">
              Tengo preguntas
            </a>
          </motion.div>

          <motion.p variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
          once: true
        }} className="text-[11px] text-[#F6F2E9]/20 mt-5 tracking-[0.05em]" data-id="element-538">
            Cupos muy limitados · Solo personas comprometidas con su
            transformación
          </motion.p>
        </div>
      </section>
      {/* MANIFESTO */}
      <section id="quien" className="py-32 px-6 md:px-16 bg-[#0C0C0C] text-center relative overflow-hidden" data-id="element-539">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_60%_50%_at_50%_50%,rgba(201,168,76,0.05),transparent)]" data-id="element-540" />
        <motion.p variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="font-serif text-[clamp(26px,4.5vw,54px)] font-light italic leading-[1.4] max-w-[900px] mx-auto mb-10 relative z-10" data-id="element-541">
          "Tu marca personal no es lo que publicas.
          <br data-id="element-542" />
          Es quien eres cuando nadie te está mirando.
          <br data-id="element-543" />Y cuando eso se alinea — el dinero, las oportunidades
          <br data-id="element-544" />y la libertad se vuelven{' '}
          <em className="text-[#C9A84C] not-italic" data-id="element-545">inevitables.</em>"
        </motion.p>
        <motion.p variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        delay: 0.2
      }} className="text-[11px] tracking-[0.4em] text-[#C9A84C] uppercase relative z-10" data-id="element-546">
          — Daniel S.
        </motion.p>
      </section>
      {/* FOR WHO */}
      <section className="py-32 px-6 md:px-16 bg-[#060606] relative overflow-hidden" data-id="element-547">
        <div className="absolute w-[400px] h-[400px] rounded-full blur-[80px] bg-[radial-gradient(circle,rgba(201,168,76,0.06),transparent_70%)] -left-[15%] top-[20%] opacity-50 animate-[orbFloat_22s_linear_infinite]" data-id="element-548" />
        <div className="absolute right-[-100px] top-1/2 -translate-y-1/2 w-[500px] h-[500px] border border-[#F6F2E9]/10 rounded-full pointer-events-none" data-id="element-549" />
        <div className="absolute right-[-50px] top-1/2 -translate-y-1/2 w-[300px] h-[300px] border border-[#C9A84C]/10 rounded-full pointer-events-none" data-id="element-550" />

        <div className="max-w-[1100px] mx-auto grid md:grid-cols-2 gap-12 md:gap-24 items-center relative z-10" data-id="element-551">
          <div data-id="element-552">
            <motion.div variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} className="tag-line" data-id="element-553">
              <span data-id="element-554">¿Para quién es esto?</span>
            </motion.div>
            <motion.h2 variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} className="big-title" data-id="element-555">
              Para quien sabe
              <br data-id="element-556" />
              que hay <em data-id="element-557">más</em>
              <br data-id="element-558" />
              dentro de él.
            </motion.h2>

            <motion.div variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="flex flex-col gap-1" data-id="element-559">
              {[{
              n: 'I',
              t: 'Tienes un trabajo, una idea o una marca — pero no genera lo que mereces.'
            }, {
              n: 'II',
              t: 'Sabes que podrías monetizar lo que sabes, pero no tienes la estructura.'
            }, {
              n: 'III',
              t: 'Quieres construir algo tuyo, desde cualquier lugar del mundo.'
            }, {
              n: 'IV',
              t: 'Entiendes que para cambiar tus resultados, primero debes cambiar quien eres.'
            }, {
              n: 'V',
              t: 'Buscas una comunidad que te eleve, no que te consuma el tiempo.'
            }].map((item, i) => <div key={i} className="bg-[#111111] p-6 md:p-7 flex gap-5 items-start transition-all duration-300 border-l-2 border-transparent hover:bg-[#181818] hover:border-[#C9A84C] hover:translate-x-1" data-id="element-560">
                  <span className="font-serif text-[22px] text-[#C9A84C] shrink-0 leading-none mt-0.5" data-id="element-561">
                    {item.n}
                  </span>
                  <p className="text-[14px] leading-[1.75] text-[#F6F2E9]/60" data-id="element-562">
                    {item.t}
                  </p>
                </div>)}
            </motion.div>
          </div>

          <motion.div variants={revealRightVariants} initial="hidden" whileInView="visible" viewport={{
          once: true
        }} className="relative hidden md:block" data-id="element-563">
            <div className="bg-[#111111] aspect-[3/4] relative overflow-hidden border border-[#C9A84C]/15" data-id="element-564">
              <img src="https://cdn.magicpatterns.com/uploads/6uWfPuDJ4S74kELu7eQGqo/daniel_sanchez_portada_el_poder_de_tu_Marca.jpg" alt="Daniel S." className="w-full h-full object-cover opacity-80" data-id="element-565" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#060606] via-transparent to-transparent opacity-60" data-id="element-566" />
            </div>
            <div className="absolute bottom-8 -left-7 bg-[#C9A84C] py-4 px-6" data-id="element-567">
              <p className="text-[10px] tracking-[0.3em] uppercase text-[#060606] font-medium" data-id="element-568">
                Daniel S. · Estratega & Mentor
              </p>
            </div>
            <div className="absolute top-8 -right-5 bg-[#0C0C0C] border border-[#F6F2E9]/10 py-5 px-6 text-center" data-id="element-569">
              <div className="font-serif text-[36px] text-[#C9A84C] leading-none" data-id="element-570">
                3
              </div>
              <div className="text-[9px] tracking-[0.3em] uppercase text-[#F6F2E9]/60 mt-1" data-id="element-571">
                Programas
              </div>
            </div>
          </motion.div>
        </div>
      </section>
      {/* PILLARS */}
      <section className="py-32 px-6 md:px-16 bg-[#0C0C0C] relative overflow-hidden" data-id="element-572">
        <div className="max-w-[1100px] mx-auto" data-id="element-573">
          <div className="grid md:grid-cols-2 gap-12 md:gap-20 items-end mb-20" data-id="element-574">
            <div data-id="element-575">
              <motion.div variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
              once: true
            }} className="tag-line" data-id="element-576">
                <span data-id="element-577">El método</span>
              </motion.div>
              <motion.h2 variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
              once: true
            }} className="big-title mb-0" data-id="element-578">
                Todo se construye
                <br data-id="element-579" />
                sobre <em data-id="element-580">tres pilares</em>
              </motion.h2>
            </div>
            <motion.p variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="text-[15px] text-[#F6F2E9]/60 leading-[1.85]" data-id="element-581">
              Este no es un programa de información. Es un sistema de
              transformación. Cada pilar activa el siguiente — y juntos crean
              resultados que no se pueden ignorar.
            </motion.p>
          </div>

          <div className="grid md:grid-cols-3 gap-1" data-id="element-582">
            {[{
            n: '01',
            w: 'SER',
            d: 'Identidad, mentalidad, energía y propósito. Trabajamos quién necesitas ser para atraer lo que quieres. Sin esto, toda estrategia es vacía.'
          }, {
            n: '02',
            w: 'HACER',
            d: 'Acciones estratégicas correctas. Marca personal, proyectos digitales, monetización con IA. Movimiento con dirección real.'
          }, {
            n: '03',
            w: 'TENER',
            d: 'Los resultados son inevitables cuando el ser y el hacer están alineados. Ingresos, libertad, impacto — no como suerte, sino como consecuencia.'
          }].map((p, i) => <motion.div key={i} variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-[#111111] p-16 md:p-11 relative overflow-hidden transition-all duration-500 hover:bg-[#181818] hover:-translate-y-1 group" data-id="element-583">
                <div className="absolute inset-0 bg-gradient-to-br from-[#C9A84C]/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-584" />
                <div className="w-full h-[2px] bg-gradient-to-r from-[#C9A84C] to-transparent mb-11 origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500" data-id="element-585" />
                <div className="font-serif text-[100px] text-[#C9A84C]/10 font-light leading-none mb-6 italic" data-id="element-586">
                  {p.n}
                </div>
                <div className="font-serif text-[36px] text-[#C9A84C] font-normal mb-4" data-id="element-587">
                  {p.w}
                </div>
                <p className="text-[14px] leading-[1.85] text-[#F6F2E9]/60 relative z-10" data-id="element-588">
                  {p.d}
                </p>
                <div className="absolute bottom-8 right-8 text-[20px] text-[#C9A84C]/30 transition-all duration-300 group-hover:text-[#C9A84C] group-hover:translate-x-1 group-hover:-translate-y-1" data-id="element-589">
                  ↗
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>
      {/* RESULTS */}
      <section className="bg-[#060606] overflow-hidden" data-id="element-590">
        <div className="flex flex-col md:flex-row gap-1" data-id="element-591">
          {[{
          n: '01',
          l: 'Una marca personal clara, poderosa y lista para atraer'
        }, {
          n: '02',
          l: 'Un proyecto digital que genera ingresos desde cualquier lugar'
        }, {
          n: '03',
          l: 'Una identidad alineada con lo que quieres crear'
        }, {
          n: '04',
          l: 'Una comunidad que te impulsa, no que te drena'
        }].map((r, i) => <motion.div key={i} variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="flex-1 bg-[#111111] py-20 px-12 text-center transition-colors duration-300 relative overflow-hidden group hover:bg-[#181818]" data-id="element-592">
              <div className="absolute top-0 left-0 right-0 h-[2px] bg-[#C9A84C] origin-center scale-x-0 group-hover:scale-x-100 transition-transform duration-500" data-id="element-593" />
              <div className="font-serif text-[80px] font-light text-[#C9A84C] leading-none mb-4" data-id="element-594">
                {r.n}
              </div>
              <p className="text-[13px] text-[#F6F2E9]/60 leading-[1.65] max-w-[180px] mx-auto" data-id="element-595">
                {r.l}
              </p>
            </motion.div>)}
        </div>
      </section>
      {/* BEFORE / AFTER TRANSFORMATION */}
      <section className="py-32 px-6 md:px-16 bg-[#0C0C0C] relative overflow-hidden" data-id="element-596">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_70%_50%_at_50%_50%,rgba(201,168,76,0.05),transparent)]" data-id="element-597" />
        <div className="max-w-[1100px] mx-auto relative z-10" data-id="element-598">
          <div className="text-center mb-24" data-id="element-599">
            <motion.div variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} className="tag-line justify-center" data-id="element-600">
              <span data-id="element-601">La transformación</span>
            </motion.div>
            <motion.h2 variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} className="big-title mb-4 text-center" data-id="element-602">
              Tu vida antes.
              <br data-id="element-603" />
              Tu vida <em data-id="element-604">después.</em>
            </motion.h2>
            <motion.p variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="text-[#F6F2E9]/60 text-[15px] max-w-[520px] mx-auto leading-[1.85]" data-id="element-605">
              Esta no es motivación. Es lo que ocurre cuando alineas tu
              identidad con una estrategia que funciona.
            </motion.p>
          </div>

          {/* Before / After Grid */}
          <motion.div variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
          once: true
        }} className="grid md:grid-cols-2 gap-1 relative mb-12" data-id="element-606">
            {/* VS badge */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-10 font-serif text-[14px] tracking-[0.3em] text-[#C9A84C] bg-[#0C0C0C] py-2.5 px-3.5 border border-[#C9A84C]/25 hidden md:block" data-id="element-607">
              VS
            </div>

            {/* BEFORE */}
            <div className="bg-[#111111] p-14 border-t-2 border-[#F6F2E9]/10" data-id="element-608">
              <p className="text-[10px] tracking-[0.5em] uppercase text-[#F6F2E9]/30 mb-6 flex items-center gap-2.5 before:content-[''] before:w-5 before:h-px before:bg-current" data-id="element-609">
                Antes
              </p>
              <h3 className="font-serif text-[clamp(22px,2.8vw,32px)] font-light leading-[1.2] mb-9 text-[#F6F2E9]/60" data-id="element-610">
                La versión de ti
                <br data-id="element-611" />
                que sigue esperando.
              </h3>
              <div className="flex flex-col gap-1" data-id="element-612">
                {['Sabes que tienes talento pero no sabes cómo monetizarlo', 'Consumes contenido todo el día y no ejecutas nada', 'Tu marca personal es inconsistente o no existe', 'Dependes de un trabajo o cliente que no elegiste', 'Te rodeas de personas sin ambición ni dirección', 'Esperas el "momento perfecto" para empezar', 'Tu ingreso tiene un techo que tú no pusiste', 'Tu identidad no está alineada con lo que quieres atraer'].map((text, i) => <div key={i} className="flex gap-4 items-start p-[18px_20px] bg-[#181818] transition-all duration-300 hover:bg-[#202020]" data-id="element-613">
                    <div className="w-1.5 h-1.5 rounded-full bg-[#F6F2E9]/20 shrink-0 mt-1.5" data-id="element-614" />
                    <p className="text-[14px] leading-[1.7] text-[#F6F2E9]/40 line-through decoration-[#F6F2E9]/15" data-id="element-615">
                      {text}
                    </p>
                  </div>)}
              </div>
            </div>

            {/* AFTER */}
            <div className="bg-[#111111] p-14 border-t-2 border-[#C9A84C]" data-id="element-616">
              <p className="text-[10px] tracking-[0.5em] uppercase text-[#C9A84C] mb-6 flex items-center gap-2.5 before:content-[''] before:w-5 before:h-px before:bg-current" data-id="element-617">
                Después
              </p>
              <h3 className="font-serif text-[clamp(22px,2.8vw,32px)] font-light leading-[1.2] mb-9 text-[#F6F2E9]" data-id="element-618">
                La versión de ti
                <br data-id="element-619" />
                que ya construyó.
              </h3>
              <div className="flex flex-col gap-1" data-id="element-620">
                {[{
                b: 'Marca personal clara y poderosa',
                t: 'Sabes quién eres, qué vendes y a quién le hablas'
              }, {
                b: 'Proyecto digital que genera ingresos',
                t: 'Desde cualquier lugar, independientemente de lo que ya tienes'
              }, {
                b: 'Sistema de ventas funcionando',
                t: 'Contenido, funnel y automatización con IA trabajando por ti'
              }, {
                b: 'Libertad de tiempo y de lugar',
                t: 'Dejas de intercambiar tiempo por dinero'
              }, {
                b: 'Comunidad de alto nivel a tu lado',
                t: 'Personas que te empujan, no que te frenan'
              }, {
                b: 'Identidad reprogramada para atraer',
                t: 'Lo que quieres llega porque quien eres lo convoca'
              }, {
                b: 'Ingresos sin techo',
                t: 'Tú decides cuánto ganas y cuándo creces'
              }, {
                b: 'Claridad total sobre tu camino',
                t: 'Sin dudas. Sin dispersión. Con dirección real'
              }].map((item, i) => <div key={i} className="flex gap-4 items-start p-[18px_20px] bg-[#181818] transition-all duration-300 hover:bg-[#202020]" data-id="element-621">
                    <div className="w-1.5 h-1.5 rounded-full bg-[#C9A84C] shrink-0 mt-1.5" data-id="element-622" />
                    <p className="text-[14px] leading-[1.7] text-[#F6F2E9]/60" data-id="element-623">
                      <strong className="text-[#F6F2E9] font-normal block" data-id="element-624">
                        {item.b}
                      </strong>
                      {item.t}
                    </p>
                  </div>)}
              </div>
            </div>
          </motion.div>

          {/* 4 Life Areas */}
          <motion.div variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="grid grid-cols-2 md:grid-cols-4 gap-1 mb-16" data-id="element-625">
            {[{
            icon: '$',
            title: 'Dinero',
            before: 'Ingreso limitado, sin control',
            after: 'Múltiples fuentes de ingreso que trabajan mientras tú duermes'
          }, {
            icon: 'T',
            title: 'Tiempo',
            before: 'Atado a horarios ajenos',
            after: 'Tú decides cuándo, dónde y cómo trabajas'
          }, {
            icon: 'I',
            title: 'Identidad',
            before: 'Difuso, sin propósito claro',
            after: 'Marca personal definida que atrae oportunidades y personas'
          }, {
            icon: 'E',
            title: 'Entorno',
            before: 'Personas que te limitan',
            after: 'Comunidad de expansión que te empuja a tu siguiente nivel'
          }].map((area, i) => <div key={i} className="bg-[#111111] py-8 px-6 text-center relative overflow-hidden transition-all duration-500 group hover:bg-[#181818] hover:-translate-y-1" data-id="element-626">
                <div className="absolute bottom-0 left-0 right-0 h-[2px] bg-[#C9A84C] origin-center scale-x-0 group-hover:scale-x-100 transition-transform duration-500" data-id="element-627" />
                <div className="font-serif text-[36px] text-[#C9A84C]/25 mb-3 leading-none italic" data-id="element-628">
                  {area.icon}
                </div>
                <div className="font-serif text-[18px] text-[#C9A84C] mb-2" data-id="element-629">
                  {area.title}
                </div>
                <div className="text-[12px] text-[#F6F2E9]/25 line-through mb-1.5 leading-[1.5]" data-id="element-630">
                  {area.before}
                </div>
                <div className="text-[13px] text-[#F6F2E9]/60 leading-[1.6]" data-id="element-631">
                  {area.after}
                </div>
              </div>)}
          </motion.div>

          <motion.div variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="text-center" data-id="element-632">
            <a href="#planes" className="btn-g" data-id="element-633">
              <span data-id="element-634">Quiero esta transformación</span>
            </a>
          </motion.div>
        </div>
      </section>
      {/* PLANS */}
      <section id="planes" className="py-32 px-6 md:px-16 bg-[#060606] relative overflow-hidden" data-id="element-635">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_80%_60%_at_50%_50%,rgba(201,168,76,0.04),transparent)]" data-id="element-636" />
        <div className="max-w-[1140px] mx-auto relative z-10" data-id="element-637">
          <div className="text-center mb-24" data-id="element-638">
            <motion.div variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} className="tag-line justify-center" data-id="element-639">
              <span data-id="element-640">Elige tu nivel</span>
            </motion.div>
            <motion.h2 variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} className="big-title mb-4" data-id="element-641">
              Tres caminos.
              <br data-id="element-642" />
              <em data-id="element-643">Un destino.</em>
            </motion.h2>
            <motion.p variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="text-[#F6F2E9]/60 text-[15px] max-w-[480px] mx-auto leading-[1.85]" data-id="element-644">
              Cada plan está diseñado para un momento diferente de tu camino.
            </motion.p>
          </div>

          <div className="grid md:grid-cols-3 gap-6 md:gap-1 items-start" data-id="element-645">
            {/* PLAN 1 */}
            <motion.div variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} className="bg-[#111111] relative transition-transform duration-500 overflow-hidden group hover:-translate-y-2" data-id="element-646">
              <div className="absolute inset-0 bg-gradient-to-b from-[#C9A84C]/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-647" />
              <div className="p-11 pb-9 relative z-10" data-id="element-648">
                <p className="text-[9px] tracking-[0.5em] uppercase text-[#C9A84C] mb-3" data-id="element-649">
                  Plan 01
                </p>
                <h3 className="font-serif text-[36px] font-normal leading-[1.1] mb-2.5" data-id="element-650">
                  El Origen
                </h3>
                <p className="font-serif italic text-[15px] text-[#F6F2E9]/60 leading-[1.5] mb-9" data-id="element-651">
                  "Todo gran imperio comienza con una semilla."
                </p>
                <div className="bg-[#0C0C0C] py-7 px-8 -mx-10 flex items-baseline gap-2" data-id="element-652">
                  <div className="font-serif text-[72px] font-light text-[#C9A84C] leading-none" data-id="element-653">
                    $97
                  </div>
                  <div className="flex flex-col gap-0.5" data-id="element-654">
                    <span className="text-[14px] text-[#F6F2E9]/60" data-id="element-655">USD</span>
                    <span className="text-[11px] text-[#F6F2E9]/35 tracking-[0.05em]" data-id="element-656">
                      por mes
                    </span>
                  </div>
                </div>
              </div>
              <div className="p-10 pb-11 relative z-10" data-id="element-657">
                <ul className="flex flex-col gap-3.5 mb-10" data-id="element-658">
                  {[{
                  b: 'Comunidad Privada',
                  t: 'Grupo activo donde Daniel participa directamente.'
                }, {
                  b: 'Biblioteca de Videos',
                  t: '5 módulos completos + nuevo contenido cada mes.'
                }, {
                  b: 'Audios de Reprogramación',
                  t: 'Serie para identidad, abundancia y enfoque diario.'
                }, {
                  b: 'Recursos y Plantillas',
                  t: 'Herramientas prácticas para empezar a construir.'
                }].map((f, i) => <li key={i} className="flex gap-3.5 text-[13.5px] leading-[1.65] text-[#F6F2E9]/60 pb-3.5 border-b border-[#F6F2E9]/5 last:border-0 last:pb-0" data-id="element-659">
                      <span className="text-[#C9A84C] shrink-0 mt-0.5 text-[14px]" data-id="element-660">
                        ◈
                      </span>
                      <div data-id="element-661">
                        <strong className="text-[#F6F2E9] font-normal block mb-0.5" data-id="element-662">
                          {f.b}
                        </strong>
                        {f.t}
                      </div>
                    </li>)}
                </ul>
                <a href="#" className="block text-center p-4 text-[11px] tracking-[0.22em] uppercase transition-all duration-300 font-sans border border-[#C9A84C]/35 text-[#C9A84C] hover:bg-[#C9A84C] hover:text-[#060606]" data-id="element-663">
                  Empezar ahora
                </a>
              </div>
            </motion.div>

            {/* PLAN 2 */}
            <motion.div variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="bg-[#181818] outline outline-1 outline-[#C9A84C]/35 relative transition-transform duration-500 overflow-hidden group hover:-translate-y-2" data-id="element-664">
              <div className="absolute inset-0 bg-gradient-to-b from-[#C9A84C]/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-665" />
              <div className="p-11 pb-9 relative z-10" data-id="element-666">
                <div className="inline-block bg-[#C9A84C] text-[#060606] text-[9px] tracking-[0.3em] uppercase py-1.5 px-4 font-medium mb-7" data-id="element-667">
                  Más elegido
                </div>
                <p className="text-[9px] tracking-[0.5em] uppercase text-[#C9A84C] mb-3" data-id="element-668">
                  Plan 02
                </p>
                <h3 className="font-serif text-[36px] font-normal leading-[1.1] mb-2.5" data-id="element-669">
                  Identidad Package
                </h3>
                <p className="font-serif italic text-[15px] text-[#F6F2E9]/60 leading-[1.5] mb-9" data-id="element-670">
                  "Tu identidad es tu activo más rentable."
                </p>
                <div className="bg-black/30 py-7 px-8 -mx-10 flex items-baseline gap-2" data-id="element-671">
                  <div className="font-serif text-[72px] font-light text-[#C9A84C] leading-none" data-id="element-672">
                    $197
                  </div>
                  <div className="flex flex-col gap-0.5" data-id="element-673">
                    <span className="text-[14px] text-[#F6F2E9]/60" data-id="element-674">USD</span>
                    <span className="text-[11px] text-[#F6F2E9]/35 tracking-[0.05em]" data-id="element-675">
                      por mes
                    </span>
                  </div>
                </div>
              </div>
              <div className="p-10 pb-11 relative z-10" data-id="element-676">
                <ul className="flex flex-col gap-3.5 mb-10" data-id="element-677">
                  {[{
                  b: 'Todo lo del Origen',
                  t: 'Comunidad, videos y audios incluidos.'
                }, {
                  b: '2 Llamadas Grupales/mes',
                  t: 'Sesiones en vivo con Daniel para trabajar tu proyecto.'
                }, {
                  b: 'Construcción de Marca Personal',
                  t: 'Guiada paso a paso en los primeros 30 días.'
                }, {
                  b: 'Tu Primer Proyecto Digital',
                  t: 'Creas algo real, publicado y listo para vender.'
                }, {
                  b: 'Grupo Privado de Mentoría',
                  t: 'Solo miembros Identidad y Élite.'
                }].map((f, i) => <li key={i} className="flex gap-3.5 text-[13.5px] leading-[1.65] text-[#F6F2E9]/60 pb-3.5 border-b border-[#F6F2E9]/5 last:border-0 last:pb-0" data-id="element-678">
                      <span className="text-[#C9A84C] shrink-0 mt-0.5 text-[14px]" data-id="element-679">
                        ◈
                      </span>
                      <div data-id="element-680">
                        <strong className="text-[#F6F2E9] font-normal block mb-0.5" data-id="element-681">
                          {f.b}
                        </strong>
                        {f.t}
                      </div>
                    </li>)}
                </ul>
                <a href="#" className="block text-center p-4 text-[11px] tracking-[0.22em] uppercase transition-all duration-300 font-sans bg-[#C9A84C] text-[#060606] font-medium hover:bg-[#E8C96A]" data-id="element-682">
                  Quiero este plan
                </a>
              </div>
            </motion.div>

            {/* PLAN 3 */}
            <motion.div variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="bg-[#111111] relative transition-transform duration-500 overflow-hidden group hover:-translate-y-2" data-id="element-683">
              <div className="absolute inset-0 bg-gradient-to-b from-[#C9A84C]/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-684" />
              <div className="p-11 pb-9 relative z-10" data-id="element-685">
                <p className="text-[9px] tracking-[0.5em] uppercase text-[#C9A84C] mb-3" data-id="element-686">
                  Plan 03
                </p>
                <h3 className="font-serif text-[36px] font-normal leading-[1.1] mb-2.5" data-id="element-687">
                  Élite Group
                </h3>
                <p className="font-serif italic text-[15px] text-[#F6F2E9]/60 leading-[1.5] mb-9" data-id="element-688">
                  "SER → HACER → TENER. El camino más directo."
                </p>
                <div className="bg-[#0C0C0C] py-7 px-8 -mx-10 flex items-baseline gap-2" data-id="element-689">
                  <div className="font-serif text-[72px] font-light text-[#C9A84C] leading-none" data-id="element-690">
                    $1,500
                  </div>
                  <div className="flex flex-col gap-0.5" data-id="element-691">
                    <span className="text-[14px] text-[#F6F2E9]/60" data-id="element-692">USD</span>
                    <span className="text-[11px] text-[#F6F2E9]/35 tracking-[0.05em]" data-id="element-693">
                      por mes · cupos limitados
                    </span>
                  </div>
                </div>
              </div>
              <div className="p-10 pb-11 relative z-10" data-id="element-694">
                <ul className="flex flex-col gap-3.5 mb-10" data-id="element-695">
                  {[{
                  b: 'Todo lo anterior',
                  t: 'Acceso completo a todos los planes.'
                }, {
                  b: '2 Sesiones 1:1 con Daniel',
                  t: 'Llamadas privadas de 60 min. Tu caso, tu estrategia.'
                }, {
                  b: 'Auditoría de Marca',
                  t: 'Análisis completo + plan personalizado desde el día 1.'
                }, {
                  b: 'Co-creación Sistema de Ventas',
                  t: 'Funnel, contenido y automatización con IA.'
                }, {
                  b: 'Sala Privada Élite',
                  t: 'Acceso exclusivo a oportunidades y recursos avanzados.'
                }, {
                  b: 'Transformación SER-HACER-TENER',
                  t: 'Trabajo profundo de identidad aplicado a tu vida.'
                }].map((f, i) => <li key={i} className="flex gap-3.5 text-[13.5px] leading-[1.65] text-[#F6F2E9]/60 pb-3.5 border-b border-[#F6F2E9]/5 last:border-0 last:pb-0" data-id="element-696">
                      <span className="text-[#C9A84C] shrink-0 mt-0.5 text-[14px]" data-id="element-697">
                        ◈
                      </span>
                      <div data-id="element-698">
                        <strong className="text-[#F6F2E9] font-normal block mb-0.5" data-id="element-699">
                          {f.b}
                        </strong>
                        {f.t}
                      </div>
                    </li>)}
                </ul>
                <a href="#" className="block text-center p-4 text-[11px] tracking-[0.22em] uppercase transition-all duration-300 font-sans border border-[#C9A84C]/35 text-[#C9A84C] hover:bg-[#C9A84C] hover:text-[#060606]" data-id="element-700">
                  Aplicar al Élite Group
                </a>
              </div>
            </motion.div>
          </div>
        </div>
        ;
      </section>
      {/* MODULES */}
      <section className="py-32 px-6 md:px-16 bg-[#0C0C0C]" data-id="element-701">
        <div className="max-w-[1100px] mx-auto" data-id="element-702">
          <div className="grid md:grid-cols-2 gap-12 md:gap-20 items-end mb-20" data-id="element-703">
            <div data-id="element-704">
              <motion.div variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
              once: true
            }} className="tag-line" data-id="element-705">
                <span data-id="element-706">Lo que recibes</span>
              </motion.div>
              <motion.h2 variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
              once: true
            }} className="big-title mb-0" data-id="element-707">
                Contenido para
                <br data-id="element-708" />
                <em data-id="element-709">transformar,</em>
                <br data-id="element-710" />
                no solo informar
              </motion.h2>
            </div>
            <motion.p variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="text-[15px] text-[#F6F2E9]/60 leading-[1.85]" data-id="element-711">
              Cada módulo está construido para que salgas con algo concreto — no
              solo ideas, sino acciones que generan resultados reales.
            </motion.p>
          </div>

          <div className="grid md:grid-cols-3 gap-1" data-id="element-712">
            {[{
            n: 'MÓDULO 01',
            i: 'I',
            t: 'Identidad y Propósito',
            d: 'Quién eres, qué quieres construir y por qué. El punto de partida que la mayoría nunca trabaja.'
          }, {
            n: 'MÓDULO 02',
            i: 'II',
            t: 'Marca Personal desde Cero',
            d: 'Nombre, concepto, posicionamiento, mensaje. Una marca que atrae — no que persigue.'
          }, {
            n: 'MÓDULO 03',
            i: 'III',
            t: 'Monetización Digital',
            d: 'Servicios, productos digitales, mentoría, e-commerce. Los modelos que generan ingresos reales.'
          }, {
            n: 'MÓDULO 04',
            i: 'IV',
            t: 'IA para Crear y Vender',
            d: 'Usa inteligencia artificial para producir contenido, automatizar ventas y construir proyectos rápido.'
          }, {
            n: 'MÓDULO 05',
            i: 'V',
            t: 'Mentalidad de Expansión',
            d: 'Reprogramación profunda. Los patrones que te frenan y cómo romperlos. Disciplina sostenida.'
          }, {
            n: 'BONUS',
            i: '◈',
            t: 'Audios de Reprogramación',
            d: 'Serie de audios para escuchar al despertar, al trabajar y al dormir. Reprograma mientras vives.'
          }].map((m, i) => <motion.div key={i} variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} transition={{
            delay: i % 3 * 0.1
          }} className="bg-[#111111] p-11 transition-all duration-500 relative overflow-hidden group hover:bg-[#181818] hover:-translate-y-1" data-id="element-713">
                <div className="absolute bottom-0 left-0 w-full h-[2px] bg-[#C9A84C] origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500" data-id="element-714" />
                <p className="text-[10px] tracking-[0.45em] text-[#C9A84C]/50 mb-6 font-normal" data-id="element-715">
                  {m.n}
                </p>
                <div className="font-serif text-[48px] text-[#C9A84C]/15 italic mb-5 leading-none" data-id="element-716">
                  {m.i}
                </div>
                <h3 className="font-serif text-[22px] font-normal mb-3" data-id="element-717">
                  {m.t}
                </h3>
                <p className="text-[13.5px] leading-[1.8] text-[#F6F2E9]/60" data-id="element-718">
                  {m.d}
                </p>
              </motion.div>)}
          </div>
        </div>
        ;
      </section>
      {/* ABOUT */}
      <section id="daniel" className="py-32 px-6 md:px-16 bg-[#0C0C0C] relative overflow-hidden" data-id="element-719">
        <div className="max-w-[1100px] mx-auto grid md:grid-cols-2 gap-12 md:gap-24 items-center" data-id="element-720">
          <motion.div variants={revealLeftVariants} initial="hidden" whileInView="visible" viewport={{
          once: true
        }} className="relative hidden md:block" data-id="element-721">
            <div className="grid grid-cols-2 gap-4 relative" data-id="element-722">
              <div className="col-span-1 row-span-2 relative rounded-sm overflow-hidden border border-[#C9A84C]/10 h-full" data-id="element-723">
                <img src="https://cdn.magicpatterns.com/uploads/kDbp1ELJHahjuMYH9ZtHgN/IMG_2454.jpg" alt="Daniel S." className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700" style={{
                minHeight: '400px'
              }} data-id="element-724" />
              </div>
              <div className="col-span-1 h-48 relative rounded-sm overflow-hidden border border-[#C9A84C]/10" data-id="element-725">
                <img src="https://cdn.magicpatterns.com/uploads/98jWgCwtf65JZCaDTbFsEv/IMG_2455.jpg" alt="Daniel S." className="w-full h-full object-cover object-top grayscale hover:grayscale-0 transition-all duration-700" data-id="element-726" />
              </div>
              <div className="col-span-1 h-48 relative rounded-sm overflow-hidden border border-[#C9A84C]/10" data-id="element-727">
                <img src="https://cdn.magicpatterns.com/uploads/vGBV3uwNxEUEnR6YDg13KS/IMG_2456.jpg" alt="Daniel S." className="w-full h-full object-cover object-top grayscale hover:grayscale-0 transition-all duration-700" data-id="element-728" />
              </div>
            </div>

            <div className="absolute bottom-10 -left-9 bg-[#C9A84C] py-4 px-6 z-10" data-id="element-729">
              <p className="text-[10px] tracking-[0.3em] uppercase text-[#060606] font-medium" data-id="element-730">
                Daniel S. · Estratega & Mentor
              </p>
            </div>
            <div className="absolute top-12 -right-7 bg-[#0C0C0C] border border-[#F6F2E9]/10 py-5 px-6 text-center z-10" data-id="element-731">
              <div className="font-serif text-[32px] text-[#C9A84C] leading-none" data-id="element-732">
                3+
              </div>
              <div className="text-[9px] tracking-[0.25em] uppercase text-[#F6F2E9]/60 mt-1.5" data-id="element-733">
                Años de
                <br data-id="element-734" />
                resultados
              </div>
            </div>
          </motion.div>

          <div data-id="element-735">
            <motion.div variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} className="tag-line" data-id="element-736">
              <span data-id="element-737">¿Quién es Daniel S.?</span>
            </motion.div>
            <motion.h2 variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} className="big-title" data-id="element-738">
              Construido desde
              <br data-id="element-739" />
              <em data-id="element-740">adentro</em>
              <br data-id="element-741" />
              hacia afuera.
            </motion.h2>

            <motion.p variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="text-[15px] leading-[1.9] text-[#F6F2E9]/60 mb-4" data-id="element-742">
              No soy un gurú de internet. Soy alguien que construyó marcas
              reales, falló, ajustó y encontró el sistema que funciona — y ahora
              lo enseña sin filtros.
            </motion.p>
            <motion.p variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} transition={{
            delay: 0.3
          }} className="text-[15px] leading-[1.9] text-[#F6F2E9]/60 mb-10" data-id="element-743">
              Dirijo Believe Marketing Agency, la marca de fragancias Benedetto
              y varios proyectos digitales. Todo bajo el mismo principio:
              identidad primero, estrategia después.
            </motion.p>

            <motion.div variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="flex flex-col my-10" data-id="element-744">
              {['Estratega de marketing orientado a resultados', 'Constructor de marcas digitales y físicas', 'Integración de espiritualidad y negocio', 'Fundador de Believe Marketing Agency', 'Creador de la marca Benedetto'].map((v, i) => <div key={i} className="flex items-center gap-5 py-4 border-b border-[#F6F2E9]/10 text-[13.5px] text-[#F6F2E9]/60 transition-colors duration-300 hover:text-[#F6F2E9] group" data-id="element-745">
                  <div className="w-6 h-px bg-[#C9A84C] shrink-0 transition-all duration-300 group-hover:w-10" data-id="element-746" />
                  {v}
                </div>)}
            </motion.div>

            <motion.div variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} transition={{
            delay: 0.3
          }} className="mt-12" data-id="element-747">
              <a href="#" className="btn-g" data-id="element-748">
                <span data-id="element-749">Trabajar con Daniel</span>
              </a>
            </motion.div>
          </div>
        </div>
        ;
      </section>
      {/* FAQ */}
      <section className="py-32 px-6 md:px-16 bg-[#060606]" data-id="element-750">
        <div className="max-w-[1100px] mx-auto grid md:grid-cols-[1fr_1.4fr] gap-12 md:gap-24 items-start" data-id="element-751">
          <div className="md:sticky md:top-[120px]" data-id="element-752">
            <motion.div variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} className="tag-line" data-id="element-753">
              <span data-id="element-754">Preguntas</span>
            </motion.div>
            <motion.h2 variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} className="big-title" data-id="element-755">
              Lo que todos
              <br data-id="element-756" />
              quieren <em data-id="element-757">saber</em>
            </motion.h2>
            <motion.p variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="text-[14px] text-[#F6F2E9]/60 leading-[1.85] mt-4" data-id="element-758">
              Si tienes más preguntas, escríbele directamente a Daniel por
              WhatsApp.
            </motion.p>
            <motion.div variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} transition={{
            delay: 0.3
          }} className="mt-9" data-id="element-759">
              <a href="#" className="btn-g" data-id="element-760">
                <span data-id="element-761">Escribir a Daniel</span>
              </a>
            </motion.div>
          </div>

          <motion.div variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="flex flex-col gap-0.5" data-id="element-762">
            {[{
            q: '¿Necesito experiencia previa en negocios digitales?',
            a: 'No. El programa está diseñado para acompañarte desde donde estás. Si tienes experiencia, aceleramos. Si estás empezando, construimos desde la base correcta.'
          }, {
            q: '¿Cuánto tiempo necesito dedicarle por semana?',
            a: 'Con 5 a 7 horas semanales avanzas de forma consistente. El contenido está diseñado para personas ocupadas que quieren resultados reales sin desperdiciar tiempo.'
          }, {
            q: '¿Las llamadas son en vivo o grabadas?',
            a: 'Las llamadas grupales son en vivo y quedan grabadas para que puedas revisarlas. Las sesiones 1:1 del Élite Group son en vivo y completamente privadas.'
          }, {
            q: '¿Puedo cambiar de plan más adelante?',
            a: 'Sí. Puedes hacer upgrade en cualquier momento. Muchos miembros empiezan en El Origen y escalan cuando están listos para más compromiso y resultados.'
          }, {
            q: '¿Qué pasa si ya tengo una marca o negocio?',
            a: 'Perfecto. Trabajamos con lo que tienes para potenciarlo, clarificarlo y escalarlo. Tener algo avanzado es una ventaja, no un obstáculo.'
          }, {
            q: '¿El Élite Group tiene cupos ilimitados?',
            a: 'No. El Élite Group es limitado para garantizar atención real y resultados concretos. Cuando los cupos se llenan, cierra. Si lo estás considerando, actúa.'
          }].map((faq, i) => <div key={i} className="bg-[#111111] overflow-hidden" data-id="element-763">
                <div onClick={() => toggleFaq(i)} className={`p-6 md:px-7 md:py-6 cursor-pointer flex justify-between items-center text-[14.5px] transition-colors duration-300 select-none gap-4 leading-[1.5] ${openFaq === i ? 'text-[#C9A84C]' : 'hover:text-[#C9A84C]'}`} data-id="element-764">
                  {faq.q}
                  <span className={`text-[#C9A84C] text-[18px] font-serif font-light shrink-0 transition-transform duration-300 ${openFaq === i ? 'rotate-45' : ''}`} data-id="element-765">
                    +
                  </span>
                </div>
                <div className={`text-[13.5px] leading-[1.85] text-[#F6F2E9]/60 overflow-hidden transition-all duration-500 ease-in-out px-6 md:px-7 ${openFaq === i ? 'max-h-[200px] pb-6' : 'max-h-0 pb-0'}`} data-id="element-766">
                  {faq.a}
                </div>
              </div>)}
          </motion.div>
        </div>
        ;
      </section>
      {/* CTA FINAL */}
      <section id="contacto" className="py-44 px-10 bg-[#0C0C0C] text-center relative overflow-hidden" data-id="element-767">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_80%_70%_at_50%_50%,rgba(201,168,76,0.07),transparent)]" data-id="element-768" />
        <div className="absolute inset-0 bg-[linear-gradient(rgba(201,168,76,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(201,168,76,0.03)_1px,transparent_1px)] bg-[length:60px_60px]" data-id="element-769" />

        <div className="relative z-10" data-id="element-770">
          <motion.p variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
          once: true
        }} className="text-[10px] tracking-[0.55em] uppercase text-[#C9A84C] mb-8" data-id="element-771">
            El momento es ahora
          </motion.p>
          <motion.h2 variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
          once: true
        }} className="font-serif text-[clamp(48px,9vw,120px)] font-light leading-[0.9] mb-8" data-id="element-772">
            El cambio
            <br data-id="element-773" />
            <em className="italic text-[#C9A84C]" data-id="element-774">empieza</em>
            <br data-id="element-775" />
            contigo.
          </motion.h2>
          <motion.p variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-[16px] text-[#F6F2E9]/60 max-w-[500px] mx-auto mb-16 leading-[1.85]" data-id="element-776">
            No hay un momento perfecto para empezar. Solo hay personas que
            decidieron — y personas que siguen esperando. ¿Cuál eres tú?
          </motion.p>
          <motion.div variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="flex gap-4 justify-center flex-wrap" data-id="element-777">
            <a href="#" className="btn-g" data-id="element-778">
              <span data-id="element-779">Hablar con Daniel por WhatsApp</span>
            </a>
            <a href="#planes" className="btn-o" data-id="element-780">
              Ver los planes
            </a>
          </motion.div>
        </div>
      </section>
      {/* FOOTER */}
      <footer className="bg-[#060606] border-t border-[#F6F2E9]/10 py-12 px-6 md:px-16 flex flex-col md:flex-row justify-between items-center gap-4 text-center" data-id="element-781">
        <div className="font-serif text-[16px] tracking-[0.4em] text-[#C9A84C] uppercase" data-id="element-782">
          Élite Identity
        </div>
        <p className="text-[11px] text-[#F6F2E9]/20 tracking-[0.06em]" data-id="element-783">
          © 2026 Daniel S. · Todos los derechos reservados
        </p>
      </footer>
      ;
    </main>;
}